const TOKEN_KEY = 'accessToken';

export const tokenManager = {
  setToken: (token) => {
    if (token) {
      localStorage.setItem(TOKEN_KEY, token);
    }
  },
  getToken: () => {
    return localStorage.getItem(TOKEN_KEY);
  },
  clearToken: () => {
    localStorage.removeItem(TOKEN_KEY);
  },
};